<template>
  <el-form-item label="所属组织">
    <el-select
      v-model="selectVal"
      multiple
      filterable
      remote
      collapse-tags
      :remote-method="remoteMethod"
      placeholder="全部"
      :loading="loading"
      :popper-append-to-body="false"
      @remove-tag="handleRemoveTag"
      @clear="clearAll"
      clearable
      style="width: 268px"
    >
      <el-option style="height: 100%; padding: 0" value="">
        <el-tree
          style="width: 100%; padding: 10px 20px 10px 0"
          ref="tree"
          show-checkbox
          :data="options"
          :props="defaultProps"
          highlight-current
          :expand-on-click-node="true"
          node-key="code"
          @check-change="handleNodeChange"
          :default-checked-keys="defaultKeys"
          :filter-node-method="filterNode"
        >
        </el-tree>
      </el-option>
    </el-select>
  </el-form-item>
</template>
<script>
export default {
  name: 'SelectTree',
  props: {
    title: {
      type: String,
      default: ''
    },
    /**
     * tree data
     */
    options: {
      type: Array,
      default: () => []
    },
    defaultProps: {
      default: () => {}
    },
    defaultKeys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      selectVal: [],
      selectItem: []
    }
  },
  watch: {
    defaultKeys: {
      handler(val) {
        if (val && val.length) {
          const init = () => {
            if (this.selectVal.length !== val.length) {
              setTimeout(() => {
                this.setSelectVal()
                init()
              }, 500)
            }
          }

          this.$nextTick(() => {
            init()
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 选择门店
     */
    handleNodeChange(data, self, child) {
      this.loading = true
      this.setSelectVal().then((res) => {
        this.loading = false
      })
    },
    setSelectVal() {
      return new Promise((resolve) => {
        let datalist = this.$refs.tree.getCheckedNodes(true)
        this.selectItem = datalist
        this.selectVal = []
        datalist.forEach((item) => {
          this.selectVal.push(item.name)
        })

        resolve()
      })
    },
    /**
     * 删除已选门店
     */
    handleRemoveTag(value) {
      this.selectItem.splice(0, 1)
      let setList = this.$refs.tree.getCheckedNodes(true)
      setList.splice(0, 1)
      this.$nextTick(() => {
        this.$refs.tree.setCheckedNodes(setList)
      })
    },
    /**
     * 清空全部
     */
    clearAll() {
      this.selectVal = []
      this.selectItem = []
      this.$nextTick(() => {
        this.$refs.tree.setCheckedNodes([])
      })
    },
    remoteMethod(query) {
      this.$refs.tree.filter(query)
    },
    // 模糊搜索，搜索父节点展开其所有子节点
    // 思路：递归把要筛选的自身到父级、父级的父级、等字段拼接成字符串，然后筛选方法内去判断当前字符串是否包含要搜索内容，实现搜索父级关键字子级显示效果。
    filterNode(value, data, node) {
      let names = this.getParents(node, node.data.name, 'name')
      let isName = names.indexOf(value) !== -1
      return !value || isName ? true : false
    },
    getParents(node, name, key) {
      function getName(node, name, key) {
        if (node.parent && node.parent.data[key]) {
          name += node.parent.data[key]
          return getName(node.parent, name, key)
        }
        return name
      }
      return getName(node, name, key)
    }
  }
}
</script>
<style scoped>
.el-select__tags-text {
  max-width: 165px;
}
</style>
